export class timespanConstants {
    static readonly Seconds = 1;
    static readonly Minutes = 2;
    static readonly Hours = 3;
    static readonly Days = 4;
    static readonly Months = 5;
    static readonly Years = 6;
}